module.exports = __webpack_public_path__ + "static/img/banner.d2f04ca5.png";